<ng-container>
  <div class="modal-body">
    <form [formGroup]="signingAgentInformationForm" class="clrsgn-form">
      <div class="row">
        <div class="col-6">
          <mat-form-field appearance="fill" class="filter-mat-form">
            <mat-label for="participantRole" class="filter-label">
              Participant Role
            </mat-label>
            @if ((isEditing$ | async)) {
              <input matInput formControlName="participantRole" [readonly]="true" />
            }
            @if (!(isEditing$ | async)) {
              <mat-select
                formControlName="participantRole"
                id="participantRole">
                @for (userRole of userRoles; track userRole) {
                  <mat-option
                    [value]="userRole.key">
                    {{ userRole.value }}
                  </mat-option>
                }
              </mat-select>
            }
            <app-form-error [group]="signingAgentInformationForm"
            [controlName]="'participantRole'"></app-form-error>
          </mat-form-field>
        </div>
      </div>
      @if (((clients && clients.length) && (isSettlementAgent || isOrderManager)) || isSystemAccountUser) {
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="fill" class="filter-mat-form">
              <mat-label for="existingClient" class="filter-label">
                Agent
              </mat-label>
              <mat-select (selectionChange)="onClientChanged($event.value)"
                (openedChange)="onSaDropdownOpened(agentSearchInput)"
                formControlName="existingClient"
                id="existingClient">
                <small class="text-muted ps-3">Search:</small>
                <input matInput #agentSearchInput placeholder="Search" class="ps-3 pt-2" (input)="performSigningAgentFilter($event)">
                <mat-option value="removeSelection">
                  Remove Selection
                </mat-option>
                @for (client of clientsSearchFiltered; track client) {
                <mat-option
                  [value]="client">
                  {{ client.fullSearch }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-6">
          <mat-form-field appearance="fill" class="filter-mat-form">
            <mat-label for="emailAddress" class="filter-label">
              Email Address
            </mat-label>
            <input matInput
              maxlength="128"
              type="text"
              formControlName="emailAddress"
              id="emailAddress" />
              <app-form-error [group]="signingAgentInformationForm"
                [controlName]="'emailAddress'"
              [customErrorMessage]="customErrorMessage"></app-form-error>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="fill" class="filter-mat-form">
              <mat-label for="confirmEmailAddress" class="filter-label">
                Confirm Email Address
              </mat-label>
              <input matInput
                maxlength="128"
                type="text"
                formControlName="confirmEmailAddress"
                id="confirmEmailAddress" />
                <app-form-error [group]="signingAgentInformationForm"
                [controlName]="'confirmEmailAddress'"></app-form-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <mat-form-field appearance="fill" class="filter-mat-form">
                <mat-label for="firstName" class="filter-label">
                  First Name
                </mat-label>
                <input matInput
                  maxlength="200"
                  type="text"
                  formControlName="firstName"
                  id="firstName" />
                  <app-form-error [group]="signingAgentInformationForm"
                  [controlName]="'firstName'"></app-form-error>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field appearance="fill" class="filter-mat-form">
                  <mat-label for="lastName" class="filter-label">
                    Last Name
                  </mat-label>
                  <input matInput
                    maxlength="200"
                    type="text"
                    formControlName="lastName"
                    id="lastName" />
                    <app-form-error [group]="signingAgentInformationForm"
                    [controlName]="'lastName'"></app-form-error>
                  </mat-form-field>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button"
              class="btn-secondary"
              data-bs-dismiss="modal"
              (click)="resetModal('cancel')">
              Cancel
            </button>
            @if (isEditing$ | async) {
              <button
                type="button"
                class="btn-primary"
                (click)="updateParticipant()">
                Save Participant
              </button>
            }
            @if (!(isEditing$ | async)) {
              <button
                type="button"
                class="btn-primary"
                data-bs-dismiss="modal"
                (click)="addParticipant()">
                Add Participant
              </button>
            }
          </div>
        </ng-container>
